import React, { useState } from 'react';

import styles from './PasswordInput.module.css';
import Input, { Props as InputProps } from '../input/Input';
import Checkbox from '../checkbox/Checkbox';

export type Props = InputProps;

const PasswordInput = (inputProps: InputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className={styles.root}>
      <Input {...inputProps} type={showPassword ? 'text' : 'password'} />
      <div className={styles.showPassword}>
        <Checkbox
          id="show-password"
          className={styles.checkbox}
          onClick={() => setShowPassword(!showPassword)}
          label="Show password"
          inlineLabel
        />
      </div>
    </div>
  );
};

export default PasswordInput;
